import React, { memo } from 'react';
import { ArrowSlideWrapper } from './styled';

interface Props {
  onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
}

export const ArrowLeft = memo(({ children, ...rest }: Props) => (
  <ArrowSlideWrapper {...rest} className="control-prev">
    <i aria-hidden className="fa fa-chevron-left" />
    {children}
  </ArrowSlideWrapper>
));

export const ArrowRight = memo(({ children, ...rest }: Props) => (
  <ArrowSlideWrapper {...rest} className="control-next">
    <i aria-hidden className="fa fa-chevron-right" />
    {children}
  </ArrowSlideWrapper>
));
